import { Dialog, DialogProps, Transition } from "@headlessui/react";
import { cn } from "@mabi-ui/utils";
import { Typography } from "@mui/material";
// import { Typography, cn } from '@mabi-ui/react';
import { Fragment, ReactNode } from "react";
import { useBetterMediaQuery } from "../../hooks/useBetterMediaQuery";
import BottomSheet, { BottomSheetV2Props } from "../bottomSheet/BottomSheet";
// import BottomSheet from '../BottomSheet';

type LateralDialogProps = {
	afterLeave?: () => void;
	children: ReactNode;
	header?: string | ReactNode;
	headerAction?: ReactNode;
	footer?: ReactNode;
	DialogContainerProps?: React.HTMLAttributes<HTMLDivElement>;
	BottomSheetProps?: Omit<BottomSheetV2Props, "open" | "onClose" | "ref" | "children">;
} & DialogProps<"div">;

export const LateralDialog: React.FC<LateralDialogProps> = ({
	afterLeave,
	open,
	className,
	children,
	header,
	footer,
	headerAction,
	DialogContainerProps,
	BottomSheetProps,
	...props
}) => {
	const { className: containerClassName, ...otherDialogContainerProps } = DialogContainerProps || {};

	const isMobile = !useBetterMediaQuery("md");

	return !isMobile ? (
		<Transition appear afterLeave={afterLeave} show={open} as={Fragment}>
			<Dialog className={cn("relative z-[1000000]", className)} {...props}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className="fixed inset-0 bg-black/[0.54]" />
				</Transition.Child>

				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="translate-x-full"
					enterTo="translate-x-0"
					leave="ease-in duration-200"
					leaveFrom="translate-x-0"
					leaveTo="translate-x-full"
				>
					<div className="fixed inset-0 flex items-center justify-end">
						<Dialog.Panel as={Fragment}>
							<div
								{...otherDialogContainerProps}
								className={cn(
									"relative flex gap-6 flex-col w-auto max-w-[75%] h-full bg-white dark:bg-tertiary rounded-l-3xl shadow-xl",
									containerClassName
								)}
							>
								{typeof header === "string" ? (
									<div className="flex items-center justify-between px-16 pt-16">
										<Typography variant="h6">{header}</Typography>
										{headerAction}
									</div>
								) : (
									header
								)}
								<div className="flex-1 overflow-auto pb-6 childrenContainer">{children}</div>
								{footer}
							</div>
						</Dialog.Panel>
					</div>
				</Transition.Child>
			</Dialog>
		</Transition>
	) : (
		<BottomSheet
			open={open ?? false}
			// onSpringEnd={(ev) => {
			// 	if (ev.type === "CLOSE") {
			// 		afterLeave?.();
			// 	}
			// }}
			// closeAfterTransition
			onClose={() => props.onClose(false)}
			header={
				typeof header === "string" ? (
					<Typography variant="subtitle1" className="mt-4">
						{header}
					</Typography>
				) : (
					header
				)
			}
			footer={footer}
			className={cn(containerClassName, className)}
			{...BottomSheetProps}
		>
			<div className="childrenContainer">{children}</div>
		</BottomSheet>
	);
};
